module.exports = __webpack_public_path__ + "img/grey.d81659af.png";